firebird.directive('childTooltip', [
    function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.mouseenter(function () {
                    element.closest('div[toggle="tooltip"]').tooltip('hide');
                });

                element.mouseleave(function () {
                    element.closest('div[toggle="tooltip"]').tooltip('show');
                });
            }
        };
    }
]);
